import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Guid } from 'guid-typescript';
import { forkJoin, lastValueFrom } from 'rxjs';
import { AvenantOverviewResponse } from 'src/app/api/models/avenantOverviewResponse.model';
import { EndorsementService } from 'src/app/api/services/endorsement.service';
import { Avenant } from 'src/app/core/models/context.model';
import * as fromPolicy from 'src/app/core/state/contract';
import * as fromRoot from '../../core/state/core.state';
import * as fromEndorsement from '../../core/state/endorsement';
import * as fromPayment from '../../core/state/payment';
import * as fromSubscriber from '../../core/state/subscriber';
import {
  CONFIRM__AMENDMENT_PATH,
  ELECTRONIC_SIGNATURE_PATH_AMENDMENT,
  ROOT_PATH
} from '../constants/route.constants';

@Injectable({
  providedIn: 'root'
})
export class EndorsementOverviewService {
  constructor(
    private endorsementService: EndorsementService,
    private store: Store<fromRoot.State>,
    private router: Router
  ) {}

  public async processEndorsementOverview(
    contextId: string,
    email: string,
    estSigne: boolean,
    avenants: Avenant[]
  ) {
    const observables = avenants.map(avenant =>
      this.endorsementService.getEndorsementOverview(
        avenant.agreementId,
        Guid.parse(contextId).toJSON().value,
        email
      )
    );

    // // Attendre que toutes les requêtes soient terminées
    const results = await lastValueFrom(forkJoin(observables));

    results.forEach(data => {
      this.dispatchPolicy(data);
      this.dispatchPayment(data);
      this.dispatchSubscriber(data);
    });
    this.dispatchAvenant(avenants);

    if (estSigne) {
      this.router.navigate([`${ROOT_PATH}${CONFIRM__AMENDMENT_PATH}`]);
    } else {
      this.router.navigate([`${ROOT_PATH}${ELECTRONIC_SIGNATURE_PATH_AMENDMENT}`]);
    }
  }

  private dispatchAvenant(dataAvenant: Avenant[]) {
    const endorsementUpdates = dataAvenant.map(dataAvenant => ({
      NumeroContrat: dataAvenant.agreementId,
      RefContrat: dataAvenant.reference,
      ClientAdvisorFullName: '',
      productName: dataAvenant.productName,
      correlationId: dataAvenant.correlationId,
      isChecked: false
    }));
    this.store.dispatch(
      fromEndorsement.putEndorsements({
        payload: endorsementUpdates
      })
    );
  }

  private dispatchPolicy(dataPolicy: AvenantOverviewResponse) {
    this.store.dispatch(
      fromPolicy.patchContract({
        payload: {
          RefContrat: dataPolicy.reference,
          NumeroContrat: dataPolicy.agreementId.toString()
        }
      })
    );
  }

  private dispatchPayment(dataPolicy: AvenantOverviewResponse) {
    this.store.dispatch(
      fromPayment.patchPayment({
        payload: {
          PrefixeTel: dataPolicy.memberPhonePrefix,
          Telephone: dataPolicy.memberPhoneNumber,
          PaymentPrefixTel: dataPolicy.memberPaymentPhonePrefix,
          PaymentTelephone: dataPolicy.memberPaymentPhoneNumber
        }
      })
    );
  }

  private dispatchSubscriber(dataPolicy: AvenantOverviewResponse) {
    this.store.dispatch(
      fromSubscriber.patchSubscriber({
        payload: {
          Email: dataPolicy.memberEmail
        }
      })
    );
  }
}
